import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { styled, ThemeProvider } from '@mui/material/styles';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import theme from 'src/theme/theme';
import Header from './Header';
import MainListItems from './MainListItems';
import SnackbarNotify from '../common/SnackbarNotify';
import { useNotify } from 'src/context/ContextNotify';
const drawerWidth: number = 220;
const drawerCloseWidth: number = 80;

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  '& .MuiDrawer-paper': {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: 'border-box',
    ...(!open && {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: drawerCloseWidth,
    }),
  },
}));

type DefaultLayoutProps = {
  children?: React.ReactNode;
};

const DefaultLayout = (props: DefaultLayoutProps) => {
  const location = useLocation();
  const loginPage = location.pathname === '/login';
  const [open, setOpen] = useState(false);
  const notifyContext = useNotify();
  const [system, setSystem] = useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const handleSwitchSystem = () => {
    setSystem(!system);
  };

  return (
    <ThemeProvider theme={theme}>
      {loginPage ? (
        <>{props.children}</>
      ) : (
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <Header open={open} handleSwitchSystem={handleSwitchSystem} system={system}/>
          {!system && (
            <Drawer
              variant='permanent'
              open={open}
              sx={{
                maxHeight: '100vh',
                '& .MuiPaper-root.MuiPaper-elevation': {
                  border: 0,
                  boxShadow: '0px 5px 5px 0px rgba(0, 0, 0, 0.05)',
                  backgroundColor: '#FAFCFF',
                },
                '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before':
                  { backgroundColor: '#CCD1D9' },
              }}
            >
              <Box
                display={'flex'}
                justifyContent={'center'}
                p={'32px 0 15px'}
                height={'88px'}
              >
                <Box
                  component={'img'}
                  src={`/images/icons/logo-arukaru${open ? '-text' : ''}.svg`}
                  alt='Logo'
                />
              </Box>
              <SimpleBar style={{ height: 'calc(100vh - 165px)' }}>
                <List
                  component='nav'
                  sx={{
                    overflowX: 'hidden',
                    px: '16px',
                  }}
                >
                  <MainListItems menuFull={open} />
                </List>
              </SimpleBar>
              <Box
                onClick={toggleDrawer}
                component='img'
                src={`/images/icons/ic-arrow-${open ? 'close' : 'open'}.svg`}
                alt={'close menu'}
                width={'28px'}
                position={'absolute'}
                right={`${open ? '15px' : '26px'}`}
                bottom={'20px'}
                sx={{ cursor: 'pointer' }}
              />
            </Drawer>
          )}
          <Box
            component='main'
            sx={{
              // backgroundColor: (theme) =>
              //   theme.palette.mode === 'light'
              //     ? theme.palette.grey[100]
              //     : theme.palette.grey[900],
              backgroundColor: '#F5F8FE',
              flexGrow: 1,
              width: '100%',
              height: '100vh',
              overflow: 'auto',
              p: '76px 32px 20px',
            }}
          >
            {notifyContext.notifyMessage.show && (
              <SnackbarNotify
                content={notifyContext.notifyMessage.message}
                show={true}
                type={notifyContext.notifyMessage.type}
                handleCloseAlert={() =>
                  notifyContext.setNotifyMessage({
                    show: false,
                    message: '',
                    type: 'error',
                  })
                }
              />
            )}
            {!system ? (
              <Box>{props.children}</Box>
            ) : (
              <iframe
                src={process.env.REACT_APP_OLD_SYSTEM_URL}
                title='current system'
                width={'100%'}
                height={'100%'}
              ></iframe>
            )}
          </Box>
        </Box>
      )}
    </ThemeProvider>
  );
};

export default DefaultLayout;
